<template>
  <div class="side-navigation-menu" :class="{ 'side-navigation-menu-collapse': isSideNavCollapsed }">
    <sidebar-ondemand v-if="userAccountType == 'private_customer'" />
    <sidebar-3pl v-if="userAccountType == 'enterprise_partner' || userAccountType == 'solo_operator' " />
    <SidebarEnterpriseCustomer v-if="userAccountType == 'enterprise_customer'" />
  </div>
</template>

<script>
import Sidebar3pl from "./Sidebar3pl";
import SidebarOndemand from "./SidebarOndemand.vue";
import SidebarEnterpriseCustomer from "./SidebarEnterpriseCustomer.vue";
export default {
  components: {
    Sidebar3pl,
    SidebarOndemand,
    SidebarEnterpriseCustomer
},
  data() {
    return {
      userType: null,
    };
  },
  computed: {
    isSideNavCollapsed() {
      return this.$store.getters.isSideNavCollapsed;
    },
    userAccountType() {
      return this.$store.state.authentication.accountUserType;
    },
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("loggedInUser"));
    if(user != null){
      this.userType = user.onboardingtype;
    }
  },
  // computed: {
  //   userType() {
  //     console.log(this.$store.getters.user);
  //     console.log(this.$store.getters.userType);
  //     return this.$store.getters.userType;
  //   },
  // },
};
</script>

<style scoped>
.side-navigation-menu {
  position: fixed;
  top: 4rem;
  height: calc(100vh - 4rem);
  left: 0;
  bottom: 0;
  z-index: 100;
  width: 280px;
  background: var(--primaryblue);
  background-image: url("../../../assets/images/background-logo.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
  overflow-y: auto;
  transition: 0.2s;
}
.side-navigation-menu-collapse{
  width:0px !important; 
}
@media screen and (min-width: 768px) {
  .side-navigation-menu-collapse{
    width:100px !important; 
  }
  .side-navigation-menu {
    position: relative;
  }
}
::-webkit-scrollbar {
  width: 0.05rem;
  display: none;
}

/* Track */
::-webkit-scrollbar-track {
  display: none;
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  background: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #ffffff;
  opacity: 0.6;
  border-radius: 10px;
}
</style>
